import * as _ from "lodash";
import {BaseControlModalView, BaseControlModalViewOptions} from "../_BaseControlAppViews";
import {OrganizationCollection} from "../../../../collections/Organizations";
import {UserGroupCollection} from "../../../../collections/UserGroups";
import * as Backbone from "backbone";
import {GenericDeleteModal} from "../../../../views/modals/GenericDeleteModal";
import {ControlPermissionCollection} from "../../collections/ControlPermissions";


export class ModifyControlGroupModal extends BaseControlModalView {
    private template = _.template(require('../../templates/modals/modifyControlGroup.html'));

    constructor(options: BaseControlModalViewOptions) {
        super(<any> _.extend(options, {
            tagName: 'div',
            events: {
                'shown.bs.modal #addControlGroupModal': 'handleModalShown',
                'hidden.bs.modal #addControlGroupModal': 'handleModalHidden',
                'change .add-cgroup-modal-app-select': 'handleOrgChange',
                'change .permission-checkbox': 'handlePermissionChange',
                'click .add-cgroup-btn': 'handleAddButtonClick',

                'click .modify-cgroup-btn': 'handleModifyButtonClick',
                'click .delete-cgroup-btn': 'handleDeleteButtonClick',
                'input .add-cgroup-modal-name': 'handleInputName'
            }
        }));

        // For the base class methods
        this.modalIdSelector = 'addControlGroupModal';

        this.options.organizationCollection = new OrganizationCollection(
            this.options.organizationCollection.filter((org) => {
                return Boolean(this.options.appCollection.findWhere({
                    organization_id: org.get('id'),
                    type: 'controls',
                    enabled: 1
                }))
            }, this)
        );

        this.userGroupCollection = null;
        this.userGroupPermissionsCollections = {};

        this.handleInputName = _.debounce(this.handleInputName.bind(this), 100);
    }

    render() {
        var name = '';
        var appId = null;
        if (this.options.controlGroupId) {
            var cgroup = this.options.controlGroupCollection.findWhere({id: this.options.controlGroupId});
            name = cgroup.get('name');
            appId = cgroup.get('app_id');
        }

        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            newControlGroup: !this.options.controlGroupId,
            controlGroupId: this.options.controlGroupId,
            permissionCollection: this.options.permissionCollection,
            appsCollection: this.options.appCollection,
            name: name,
            appId: appId
        }));

        return this;
    }

    show() {
        (<any> this.$('#addControlGroupModal')).modal('show');
        this.handleOrgChange();
    }

    handleOrgChange() {
        var appId = this.$('.add-cgroup-modal-app-select').val();

        var app = this.options.appCollection.findWhere({id: Number(appId)});
        var orgId = app.get('organization_id');

        // Load permissions & render toggle buttons
    $.when(this.loadPermissionsCollections(
            orgId,
            'canViewControlGroup',
            'canModifyControlGroup',
            'canDeleteControlGroup'
        ))
        .then(() => {
            this.$('.permissions-loading').removeClass('hidden');
            this.$('.permissions-loaded').addClass('hidden');
            this.$('.add-cgroup-btn').prop('disabled', true);
            this.handleAddButtonDisabledState();
        });
    }

    getNewPermissionCollection(usergroupId) {
        // Override base method in _BaseModifyModal
        return new ControlPermissionCollection([], {userGroupId: usergroupId});
    }

    handlePermissionChange(e) {
        var target = $(e.currentTarget);
        var checked = target.is(':checked');

        if (checked) {
            if (target.hasClass('permission-modify')) {
                target.parents('tr').find('.permission-view').prop('checked', true).change()
            }
        } else {
            if (target.hasClass('permission-view')) {
                target.parents('tr').find('.permission-modify').prop('checked', false).change()
            }
        }

        this.handleAddButtonDisabledState();
    }

    handleInputName() {
        this.handleAddButtonDisabledState();
    }

    handleAddButtonDisabledState() {
        var canAssignPerms = false;
        if (this.userGroupCollection) {
            if (this.userGroupCollection.isFetching()) {
                this.$('.add-cgroup-btn').prop('disabled', true);
                this.$('.modify-cgroup-btn').prop('disabled', true);
                return;
            }

            // Only allow a new control group to be created if the user can assign permissions
            this.userGroupCollection.each((group) => {
                if (this.options.permissionCollection.canModifyUserGroupPermissions(group.get('id'))) canAssignPerms = true;
            }, this)
        }

        // Make sure the control group is named
        if (!this.$('.add-cgroup-modal-name').val() || !canAssignPerms) {
            this.$('.add-cgroup-btn').prop('disabled', true);
            this.$('.modify-cgroup-btn').prop('disabled', true);
            return;
        }

        // Make sure at least one control group has all permissions
        var allPerms = _.some(this.$('.permission-modify').map(function () {
            return $(this).is(':checked')
        }));
        this.$('.add-cgroup-btn').prop('disabled', !allPerms);
        this.$('.modify-cgroup-btn').prop('disabled', !allPerms);
    }

    handleModifyButtonClick() {
        this.sendRequest();
    }

    sendRequest() {
        var request, url;

        if (this.options.controlGroupId) {
            request = "PUT";
            url = this.options.controlGroupCollection.url() + '/' + this.options.controlGroupId;
        } else {
            request = "POST";
            url = this.options.controlGroupCollection.url();

        }

        this.setFormSubmitted();
        $.when($.ajax({
            type: request,
            url: url,
            data: JSON.stringify({
                appId: Number(this.$('.add-cgroup-modal-app-select').val()),
                name: this.$('.add-cgroup-modal-name').val(),
                permissions: this.getPermissionsDict()
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8"
        })).then((response: any) => {
            this.refetchCollectionsAndShow(this.options.controlGroupId || response.controlGroupId)
        }).fail(() => {
            this.setFormError();
        })
    }

    handleDeleteButtonClick() {
        var cgroup = this.options.controlGroupCollection.findWhere({id: this.options.controlGroupId});

        var modal = new GenericDeleteModal({
            type: 'Control Group',
            name: cgroup.get('name'),
            func: () => {
                this.setFormSubmitted();
                return $.when(cgroup.destroy()).done(() => {
                    this.refetchCollectionsAndShow();
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    handleAddButtonClick() {
        this.sendRequest();
    }

    refetchCollectionsAndShow(controlGroupId?) {
        var d1 = this.options.controlGroupCollection.getCollectionFetchPromise({reset: true});
        var d2 = this.options.permissionCollection.getCollectionFetchPromise({reset: true});

        $.when(d1, d2).done(() => {
            this.hide();
            if (!controlGroupId || controlGroupId !== this.options.controlGroupId) {
                window.location.hash = "#/controls" + (controlGroupId ? '/' + controlGroupId : '');
            } else {
                // Somewhat of a hack to refresh the page
                // See http://stackoverflow.com/questions/8901574/how-to-refresh-a-page-in-a-backbone-application
                Backbone.history.loadUrl();
            }

            window['App'].Bus.trigger('navigation:update');
        }).fail(() => {
            this.setFormError();
        })
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/controls/views/modals/ModifyControlGroupModal.ts